<template>

<app-content :loading="is.loading && !is.initialised">

	<app-content-head title="Applications" subtitle="Accept and reject applications made from non-badge holders.">

		<app-content-head-actions-panel v-if="collection.length" text="Export" icon="export" component="manager/common/panel/Export" :data="exportData" />

	</app-content-head>

	<app-content-filters :changed="isFilterDirty" v-on:reset="onResetFilter">

		<app-content-filters-search v-model="filter.search" />

		<app-content-filters-select v-model="filter.status" :allowDeselect="true" text="Application Status" prefix="Status is" tooltip="Filter by application status" :options="$util.options($constants.registration.application.statusName)" />

		<app-content-filters-select v-model="filter.suggestion" :allowDeselect="true" text="Event Status" prefix="Event is" tooltip="Filter by event status" :options="$util.options($constants.schedule.suggestions.statusName)" />

		<app-content-filters-checklist v-model="filter.pages" text="Page" tooltip="Filter by page" :options="filterPageOptions" />

		<app-content-filters-date v-model="filter.from" tooltip="Filter from date" text="From" :max="filter.to" />

		<app-content-filters-date v-model="filter.to" tooltip="Filter to date" text="To" :min="filter.from" />

	</app-content-filters>

	<app-content-body :loading="is.loading && is.initialised" :is-empty="!collection.length" placeholder="Sorry, no data application found.">

		<app-table>

			<app-table-head :layout="layout">

				<app-table-column />

				<app-table-column text="Ref" />

				<app-table-column text="Applicant" />

				<app-table-column />

				<app-table-column border="left" text="Page" />

				<app-table-column text="Submitted" />

			</app-table-head>

			<app-table-body>

				<app-table-row v-on:click="onEditClick(item.id)" :layout="layout" v-for="item in collection" :key="item.id">

					<app-table-cell-label :text="$constants.registration.application.statusName[item.status]" :type="$constants.registration.application.statusTheme[item.status]" />

					<app-table-cell-text :text="item.reference" />

					<app-table-cell-text :text="item.name" :subtext="item.email" :prefix="(item.linked.total > 1) ? item.linked.current + '/' + item.linked.total : false" :tooltip="(item.linked.total > 1) ? 'This user has submitted ' + item.linked.total + ' applications for this page.' : false" />

					<app-table-cell-labels :labels="applicationSubmissions(item)" align="right" />

					<app-table-cell-text border="left" :text="item.page.name" />

					<app-table-cell-text :text="item.date.submitted | localDate('MM/DD/YYYY h:mma')" />

				</app-table-row>

			</app-table-body>

			<app-table-foot :pagination="pagination" :total="total" />

		</app-table>

	</app-content-body>

</app-content>

</template>

<script>

import mixCollection from '@/mixin/collection'

export default {

	mixins: [mixCollection],

	data: function() {

		return {
			references: {
				pages: []
			},
			filter: {
				pages: [],
				from: 0,
				to: 0,
				suggestion: 0,
				status: 0
			},
			layout: '80px 48px minmax(0, 1fr) minmax(0, 1fr) 250px 150px',
			endpoint: 'convention/registration/applications',
			live: 'convention/registration/application'
		}

	},

	computed: {

		filterPageOptions: function() {

			var sources = []

			this.$_.each(this.references.pages, function(source) {

				sources.push({
					value: source.id,
					text: source.name
				})

			})

			return sources

		},

		exportData: function() {

			return {
				columns: {
					firstname: 'First name',
					lastname: 'Last name',
					email: 'Email',
					page: 'Page',
					date: 'Date',
					data: 'Custom Data'
				},
				requiredColumns: [],
				valueMapping: {},
				params: this.getParams(),
				index: this.selected,
				endpoint: this.endpoint
			}

		}

	},

	methods: {
	
		applicationSubmissions: function(item) {
		
			var submissions = []

			this.$_.each(item.suggestions, function(suggestion) {
			
				submissions.push({
					tooltip: this.$constants.schedule.suggestions.statusName[suggestion.status],
					type: this.$constants.schedule.suggestions.statusTheme[suggestion.status],
					text: suggestion.name				
				})
			
			}.bind(this))

			return submissions
		
		}
	
	}

}

</script>

<style scoped>

</style>